/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status_RefundedInputs */

const fr_payment_status_refunded = /** @type {(inputs: Payment_Status_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remboursé`)
};

/**

* @param {Payment_Status_RefundedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payment_status_refunded = /** @type {((inputs?: Payment_Status_RefundedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status_RefundedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payment_status_refunded(inputs)
});